/**
 * Created by Alex Aguilar on 9/6/2016.
 */
(function () {
    'use strict';

    var remoteUniqueEmail = {
        templateUrl: 'app/components/validate/remoteValidateUnique.html',
        controller: remoteUniqueEmailController,
        controllerAs: 'vm',
        require: {
            model: "ngModel"
        },
        bindings: {
            formName: '<'
        }
    }

    angular
        .module('completeAir')
        .component('remoteUniqueEmail', remoteUniqueEmail)

    remoteUniqueEmailController.$inject = ['$element', '$timeout',  'forgotService'];

    function remoteUniqueEmailController($element, $timeout, forgotService) {
        var vm = this;
        vm.value = "";
        vm.isLoad = false;
        vm.valueCurrent = "";

        vm.$onInit = function () {
            var input = $element.parent(),
                inputJQ = input.find('.form-control');

            inputJQ.keydown(function () {
                $timeout(function () {
                    vm.value = vm.model.$viewValue;
                    if (vm.value !== undefined && vm.value !== "") {
                        if(validateEmail(vm.value)) {
                            forgotService.thereEmail(vm.value).then(function (response) {
                                if (response.data === true) {
                                    vm.formName.$setValidity('uniqueForgotUserEmail', true);
                                } else {
                                    vm.formName.$setValidity('uniqueForgotUserEmail', false);
                                }
                                vm.isLoad = false;
                            });
                        }

                    }
                });
            });
        };
    }

    function validateEmail(email) {
        var re = /^(([a-zA-Z0-9_.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([;,.](([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/;
        return re.test(email);
    }
})();

